var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M19.3242 7.86178V14.1317C19.3242 15.1584 18.7742 16.1118 17.8851 16.6343L12.4401 19.7784C11.5509 20.2918 10.4509 20.2918 9.55254 19.7784L4.10754 16.6343C3.21837 16.1209 2.66837 15.1676 2.66837 14.1317V7.86178C2.66837 6.83511 3.21837 5.88174 4.10754 5.35924L9.55254 2.21508C10.4417 1.70174 11.5417 1.70174 12.4401 2.21508L17.8851 5.35924C18.7742 5.88174 19.3242 6.82594 19.3242 7.86178Z",
    fill: "#35446F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 12.5957C10.6242 12.5957 10.3125 12.284 10.3125 11.9082V7.0957C10.3125 6.71987 10.6242 6.4082 11 6.4082C11.3758 6.4082 11.6875 6.71987 11.6875 7.0957V11.9082C11.6875 12.284 11.3758 12.5957 11 12.5957Z",
    fill: "#35446F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9956 15.803C10.8764 15.803 10.7572 15.7755 10.6472 15.7297C10.5281 15.6838 10.4364 15.6197 10.3447 15.5372C10.2622 15.4455 10.1981 15.3447 10.1431 15.2347C10.0973 15.1247 10.0789 15.0055 10.0789 14.8863C10.0789 14.648 10.1706 14.4097 10.3447 14.2355C10.4364 14.153 10.5281 14.0889 10.6472 14.043C10.9864 13.8964 11.3898 13.9788 11.6464 14.2355C11.7289 14.3272 11.7931 14.4188 11.8389 14.538C11.8847 14.648 11.9123 14.7672 11.9123 14.8863C11.9123 15.0055 11.8847 15.1247 11.8389 15.2347C11.7931 15.3447 11.7289 15.4455 11.6464 15.5372C11.4723 15.7114 11.2431 15.803 10.9956 15.803Z",
    fill: "#35446F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.3457824b826084c0c771371246f6ac9b.svg";
export { ForwardRef as ReactComponent };